import { Component, Input, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ClientesService } from "app/core/services/clientes/clientes.service";
import { columnHeader } from "app/shared/factoring-datatable/factoring-datatable.component";
import { ConfirmModalComponent } from "app/shared/utils/confirm-modal/confirm-modal.component";
import { AddFinancialRelationshipComponent } from "app/modules/clientes/modals/add-financial-relationship/add-financial-relationship.component";

@Component({
  selector: "app-antecedentes-credito-relaciones-financieras",
  templateUrl: "./relaciones-financieras.component.html",
  styleUrls: ["./relaciones-financieras.component.css"],
})
export class RelacionesFinancierasComponent implements OnInit {
  public rowData: any[] = [];
  public loadingTable: boolean = false;
  public columnDefs: columnHeader[];
  public pageTableActual: number;
  public pageTableTotal: number;
  public pageTablePerPages: number = 10;
  public pageTablePages: number[];
  public searchstring: string = "";
  public moneda_deuda: number = 2;

  @Input() clienteId = 0;
  @Input() readonly = false;

  constructor(
    private clientesService: ClientesService,
    public modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this.obtenerRelacionesFinancieras();
  }

  obtenerRelacionesFinancieras(page = 1, page_size = 10) {
    this.clientesService
      .obtenerRelacionesFinancieras(this.clienteId.toString(), page, page_size)
      .then((res) => {
        this.initVars();
        this.loadTable(res);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  loadTable(data) {
    this.rowData = data.results.map((el: any, i: number) => ({
      ...el,
      index: i + 1,
    }));
    this.pageTableActual = data.page_number;
    this.pageTableTotal = data.count;
    this.pageTablePerPages = data.per_page;
    this.pageTablePages = [];
    for (let index = 0; index < data.num_pages; index++) {
      this.pageTablePages.push(index);
    }
  }

  initVars() {
    let columns = [
      {
        headerName: "N°",
        field: "index",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Entidad Financiera",
        field: "entidad_financiera_nombre",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Sucursal",
        field: "sucursal",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Moneda",
        field: "moneda_descripcion",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Nro Cuenta",
        field: "numero_cuenta",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Sectorista",
        field: "sectorista",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Teléfono",
        field: "telefono",
        sortable: true,
      },
      {
        class: "text-center",
        headerName: "Deuda Vigente US$",
        field: "deuda_vigente",
        pipe: "currency",
        moneda: "moneda_deuda",
      },
    ];

    this.columnDefs = columns;
  }

  goToPage({ page, per_page, filtros }) {
    this.obtenerRelacionesFinancieras(page, per_page);
  }

  tableEditEvent(relation) {
    const modalRef = this.modalService.open(AddFinancialRelationshipComponent, {
      size: "lg",
    });

    modalRef.componentInstance.clienteId = this.clienteId;
    modalRef.componentInstance.relationId = relation.id;

    modalRef.componentInstance.successEmit.subscribe(
      (result) => {
        this.obtenerRelacionesFinancieras();
      },
      (error) => {}
    );
  }

  destroyContact(relation) {
    const modalRef = this.modalService.open(ConfirmModalComponent, {});

    modalRef.componentInstance.title = "Remover Relación Financiera";
    modalRef.componentInstance.message =
      "¿Seguro que desea remover la relación finaciera?";

    modalRef.result.then((result) => {
      if (result) {
        this.clientesService
          .eliminarRelacionFinanciera(relation.id)
          .then((result) => {
            this.obtenerRelacionesFinancieras();
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }

  openModal() {
    const modalRef = this.modalService.open(AddFinancialRelationshipComponent, {
      size: "lg",
    });

    modalRef.componentInstance.clienteId = this.clienteId;

    modalRef.componentInstance.successEmit.subscribe(
      (result) => {
        this.obtenerRelacionesFinancieras();
      },
      (error) => {}
    );
  }
}
